import { z } from 'zod'

import {
  abTestsCommonSchema,
  abTestsCommonSchemaDefaults,
} from '../AbTestsCommonForm/abTestsCommonSchema'

export const abTestsAddSchema = z.object({}).extend(abTestsCommonSchema.shape)

export type AbTestsAddSchema = z.infer<typeof abTestsAddSchema>

export const abTestsAddSchemaDefaults: AbTestsAddSchema = abTestsCommonSchemaDefaults
